module.exports = __webpack_public_path__ + "media/images/flags/flag_uk-f24db783bb5a3a2f6a0e12b4d076b69a.svg";